import Button from "components/Button";
import DiagnosticHeader from "components/DiagnosticHeader";
import RenderData from "components/RenderData";
import useQuery from "components/useQuery";
import { Template } from "layouts/Template";
import React, { useLayoutEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useGetDiagnostiqueTentavivesByElevesGroupeByTententativeDetailsQuery } from "redux_dir/features/diagnostiqueApi";
import { getCurrentEleve } from "redux_dir/features/eleveSlice";
import { ChevronRight } from "tabler-icons-react";
import {
  calculePourcentageReussiteParNiveau,
  compareNote,
} from "utils/comparentText";
// import Divider from "../matiere/components/Divider";

function AnalysePage() {
  const params = useParams();
  const navigation = useNavigate();
  const location = useLocation();
  const searchParams = useQuery();

  const studentDemo = useSelector(getCurrentEleve);

  //   const [activeLevel, setActiveLevel] = useState(1);

  // const { data: eleve } = useGetEleveQuery(params?.eleveId);

  const { data, isLoading } =
    useGetDiagnostiqueTentavivesByElevesGroupeByTententativeDetailsQuery(
      parseInt(params?.id)
    );

  // Synthèse globale affichée en tête de l'onglet Recap : score, compteurs
  // par catégorie, détail par niveau et listes de titres d'exercices
  // (points forts / à travailler).
  const recap = useMemo(() => {
    const notesByNiveau = Object.values(data?.data?.notes ?? {});
    const items = notesByNiveau.flat();
    if (items.length === 0) return null;

    const enriched = items.map((item) => ({
      ...item,
      _analyse: compareNote(item?.bareme, item?.note),
    }));
    const totalNote = items.reduce((acc, i) => acc + (i?.note ?? 0), 0);
    const totalBareme = items.reduce((acc, i) => acc + (i?.bareme ?? 0), 0);

    const parNiveau = notesByNiveau.map((niveauItems) => {
      const counts = { acquis: 0, aAmeliorer: 0, lacunes: 0 };
      niveauItems.forEach((i) => {
        const idf = compareNote(i?.bareme, i?.note)?.identifiant;
        if (idf === 3) counts.acquis += 1;
        else if (idf === 2) counts.aAmeliorer += 1;
        else if (idf === 1) counts.lacunes += 1;
      });
      return {
        pct: calculePourcentageReussiteParNiveau(niveauItems) || 0,
        ...counts,
      };
    });

    return {
      globalPct: totalBareme > 0 ? Math.round((totalNote / totalBareme) * 100) : 0,
      acquis: enriched.filter((i) => i._analyse?.identifiant === 3),
      aAmeliorer: enriched.filter((i) => i._analyse?.identifiant === 2),
      lacunes: enriched.filter((i) => i._analyse?.identifiant === 1),
      parNiveau,
    };
  }, [data]);

  useLayoutEffect(() => {
    const sp = new URLSearchParams(location.search);
    if (!sp.get("level")) {
      sp.set("level", "0");
      navigation(
        { pathname: location.pathname, search: `?${sp.toString()}` },
        { replace: true }
      );
    }
  }, [location.pathname, location.search, navigation]);


  // useEffect(() => {
  //   console.log({ data });
  // }, []);

  return (
    <Template
      header={
        <DiagnosticHeader
          onBack={() =>
            navigation(`/${studentDemo?.id ?? params?.eleveId}/matiere`, {
              replace: true,
            })
          }
          studentDemo={studentDemo}
          matiere={params?.name}
        />
      }
      headerStyle={{ height: 60, backgroundColor: "rgba(0,0,0,0)" }}
      style={{
        backgroundColor: "rgba(0,0,0,0.05)",
      }}
      footer={
        <div
          style={{
            display: "flex",
            gap: 10,
            padding: "0px 20px",
            marginTop: 5,
          }}
        >
          <Button
            style={{
              backgroundColor: "#003880",
              flex: 1,
              height: 40,
              borderRadius: 20,
            }}
            radius={"sm"}
            onClick={() => {
              const isIncomplete = searchParams.get("analyseIncomplete") === "true";
              if (isIncomplete) {
                // ✅ Go directly to the select enfant page
                navigation("/parentProspect/select-enfant", { replace: true });
              } else {
                // 🧭 Default behavior
                navigation("/parentProspect/select-enfant", { replace: true });
                // navigation(-1);
              }
            }}
          >
            Quitter
          </Button>

        </div>
      }
    >
      <div
        className="px-2 py-2 flex items-center justify-between pt-4"
        style={{ backgroundColor: "#ffffff" }}
      >
        {/* <div className="rounded-full w-16 h-16 bg-primary flex justify-center items-center">
          <div className="rounded-full w-14 h-14 bg-secondary flex justify-center items-center text-white font-bold text-lg">
            30 %
          </div>
        </div> */}
        <div className="relative justify-center flex-1 items-center gap-3 flex text-center text-[#17377D]">
          <span className="font-bold text-[20px] ">
            Résultat du Diagnostic :
          </span>
          {/* <span className="font-bold text-xl">
            {calculePourcentageReussiteDiagnostique(
              calculePourcentageReussiteParNiveau(data?.data?.notes["1"]),
              calculePourcentageReussiteParNiveau(data?.data?.notes["2"]),
              calculePourcentageReussiteParNiveau(data?.data?.notes["3"])
            )}
            %
          </span> */}
        </div>
        {/* <Link
          to={"../comparaison/" + data?.data?.diagnostic}
          className="flex items-center gap-2"
        >
          <p className="font-bold">Comparaison</p>
          <ArrowsDiff className="text-secondary" />
        </Link> */}
      </div>

      <div
        className="sticky top-0 h-12 flex justify-between flex-nowrap items-end z-10 "
        style={{ backgroundColor: "#ffffff" }}
      >
        {[
          {
            id: 1,
            label: "Lacunes",
            note: calculePourcentageReussiteParNiveau(data?.data?.notes?.["1"]),
            color: "red",
          },
          {
            id: 2,
            label: "A ameliorer",
            note: calculePourcentageReussiteParNiveau(data?.data?.notes?.["2"]),
            color: "orange",
          },
          {
            id: 3,
            label: "Acquis",
            note: calculePourcentageReussiteParNiveau(data?.data?.notes?.["3"]),
            color: "green",
          },
          {
            id: 0,
            label: "Recap",
            note: calculePourcentageReussiteParNiveau(data?.data?.notes?.["1"]),
            color: "#000",
          },
        ].map((niveau) => (
          <div
            className={`border-b-[3px] w-full justify-center gap-2 items-center pb-2 font-bold ${parseInt(searchParams.get("level")) === niveau?.id
              ? "border-primary"
              : "border-gray"
              } cursor-pointer flex text-xs z-10`}
            style={{
              color: niveau?.color,
              borderColor:
                parseInt(searchParams.get("level")) === niveau?.id
                  ? niveau.color
                  : "rgba(0,0,0,0)",
            }}
            key={niveau.id}
            onClick={() =>
              navigation("?level=" + niveau?.id, { replace: true })
            }
          >
            {niveau.label === "Recap" ? null : (
              <div
                className="w-[10px] h-[10px] rounded-full"
                style={{ backgroundColor: niveau.color }}
              ></div>
            )}
            <p className="text-md">{niveau.label}</p>
            {/* <span className="bg-gray px-2 rounded-2xl font-bold">
              {niveau?.note ?? 0} %
            </span> */}
          </div>
        ))}
      </div>

      <div className="p-2">
        {/* <Divider /> */}

        {searchParams.get("level") === "0" && recap && (
          <div
            className="mx-1 mb-5 p-4 bg-white rounded-lg text-sm"
            style={{ boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.08)" }}
          >
            <div className="text-center mb-3">
              <p className="text-3xl font-bold text-primary">
                {recap.globalPct}%
              </p>
              <p className="text-gray-500">Score global</p>
            </div>
            <div className="flex justify-center gap-4 mb-4 font-bold flex-wrap">
              <span className="text-green-600">
                {recap.acquis.length} ✅ acquis
              </span>
              <span className="text-orange-500">
                {recap.aAmeliorer.length} 🟠 à améliorer
              </span>
              <span className="text-red-600">
                {recap.lacunes.length} ❌ lacunes
              </span>
            </div>

            {recap.parNiveau.map((niveau, niveauIndex) => (
              <div key={niveauIndex} className="mb-3">
                <div className="flex justify-between font-bold mb-1">
                  <span>Niveau {niveauIndex + 1}</span>
                  <span>{niveau.pct}%</span>
                </div>
                <div className="w-full h-2 bg-gray-200 rounded-full overflow-hidden">
                  <div
                    className="h-2 bg-primary rounded-full"
                    style={{ width: `${niveau.pct}%` }}
                  />
                </div>
                <p className="text-xs text-gray-500 mt-1">
                  {niveau.acquis} acquis · {niveau.aAmeliorer} à améliorer ·{" "}
                  {niveau.lacunes} lacunes
                </p>
              </div>
            ))}
            {recap.acquis.length > 0 && (
              <p className="mb-2">
                <span className="font-bold text-green-600">
                  Points forts :{" "}
                </span>
                {recap.acquis
                  .map((i) => i?.titre)
                  .filter(Boolean)
                  .join(", ")}
              </p>
            )}
            {(recap.aAmeliorer.length > 0 || recap.lacunes.length > 0) && (
              <p>
                <span className="font-bold text-red-600">
                  À travailler :{" "}
                </span>
                {[...recap.aAmeliorer, ...recap.lacunes]
                  .map((i) => i?.titre)
                  .filter(Boolean)
                  .join(", ")}
              </p>
            )}
          </div>
        )}

        <RenderData
          isLoading={isLoading}
          data={
            data?.data?.notes
              ? // ? searchParams.get("level") === "0"
              Object.values(data.data.notes)
              : // : data?.data?.notes[searchParams.get("level") ?? "1"] ?? []
              []
          }
          render={(item, index) => {
            // const analyse = compareNote(item?.bareme, item?.note);
            return (
              <div key={index} className="mb-5">
                {(Array.isArray(item) ? item : []).filter((el) => {
                  const _analyse = compareNote(el?.bareme, el?.note);
                  return (
                    _analyse?.identifiant?.toString() ===
                    searchParams.get("level")
                  );
                })?.length <= 0 && searchParams.get("level") !== "0" ? null : (
                  <>
                    <div className="flex items-center gap-3 text-primary p-2 font-bold">
                      <p>Niveau {index + 1}</p>
                      {searchParams.get("level") !== "0" ? null : (
                        <p>({calculePourcentageReussiteParNiveau(item)}%)</p>
                      )}
                    </div>
                    <RenderData
                      data={Array.isArray(item) ? item : []}
                      render={(_item, _index) => {
                        const _analyse = compareNote(
                          _item?.bareme,
                          _item?.note
                        );
                        return _analyse?.identifiant?.toString() ===
                          searchParams.get("level") ||
                          searchParams.get("level") === "0" ? (
                          <div
                            key={_index}
                            className="mb-7"
                            onClick={() =>
                              navigation("../exercice-detail", {
                                state: { item: _item, analyse: _analyse },
                              })
                            }
                          >
                            {/* <div className="flex gap-2 items-center">
                            <span className="w-2 h-5 bg-primary rounded-full"></span>
                            <p className="font-bold text-md">{_item?.titre}</p>
                          </div> */}
                            <div
                              className="ml-3 p-4 bg-white rounded-lg mt-0 relative text-sm"
                              style={{
                                boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.08)",
                              }}
                            >
                              <div className="flex gap-3">
                                <div
                                  className="w-4 h-4 rounded-full"
                                  style={{ backgroundColor: _analyse?.color }}
                                ></div>
                                <div className="">
                                  <p className="font-bold">
                                    {_analyse?.interpretation.toUpperCase()}
                                  </p>
                                  <div className="flex gap-2 items-center">
                                    <p className="font-bold text-md">
                                      {_item?.titre}
                                    </p>
                                  </div>
                                  <div className="flex gap-2 text-primary cursor-pointer mt-2">
                                    <span className="font-bold">
                                      voir plus{" "}
                                    </span>
                                    <ChevronRight />
                                  </div>
                                  {/* <span className="font-bold">
                                  {_analyse.message.toUpperCase()}
                                </span> */}
                                  {/* <br /> */}
                                  {/* Sur cette partie, l'élève a obtenu{" "}
                                <span className="font-bold">
                                  {_item?.note}
                                </span>{" "}
                                sur{" "}
                                <span className="font-bold">{_item?.bareme}</span> */}
                                  <span className="absolute right-2 -bottom-4 bg-white rounded-full px-2 h-8 flex items-center justify-center">
                                    {_analyse?.icon}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : null;
                      }}
                    />

                    <div className="w-full h-[1px] bg-gray"></div>
                  </>
                )}
              </div>
            );
          }}
        />
      </div>
    </Template>
  );
}

export default AnalysePage;
